import { TableContentPurchaseViewSecond, TableContentWithoutEditDateFromat } from '../../../Common/Table/tableContent';
import React from "react";
import tokenService from '../../../../Common/tokenDecoder';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import { generateStatus } from '../../satusGenerator';
import { makeStyles } from '@material-ui/core/styles';
import IconButton from '@material-ui/core/IconButton';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import Collapse from '@material-ui/core/Collapse';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';

export default class ComponentToPrint extends React.Component {
    render() {

        const orderItemArray = this.props.orderItemArray;
        const contentRowNames = this.props.contentRowNames;
        const itemDetails = this.props.itemDetails;
        const purchaseForPDF = this.props.purchaseForPDF;
        const tableHeaderStyle = {
            color: "#263238",
            textTransform: "uppercase",
            fontSize: "12px",
            fontWeight: "bold"
        }
        const subTableHeaders = {
            textTransform: "uppercase",
            fontSize: "12px"
        }
        const useRowStyles = makeStyles({
            root: {
                '& > *': {
                    borderBottom: 'unset',
                },
            },
        });

        function roundNumber(num) {
            return (Math.round(num * 100) / 100).toFixed(2);
        }

        function Row(props) {
            const { row } = props;
            const [open, setOpen] = React.useState(true);
            const classes = useRowStyles();


            return (
                <React.Fragment>
                    <TableRow className={classes.root}>
                        <TableCell component="th" scope="row">
                            {row.collectionTypeName}
                        </TableCell>
                        <TableCell align="right">{row.itemQuantity}</TableCell>
                        <TableCell align="right" component="th" scope="row">
                            {row.measuringUnit === 1 ? "Kg" : "Unit"}
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell style={{ paddingBottom: 0, paddingTop: 0, backgroundColor: "#FAFAFA" }} colSpan={6}>
                            <Collapse in={open} timeout="auto" unmountOnExit>
                                {row.supplierItems.length !== 0 ? <Box>
                                    <Typography variant="body2" gutterBottom component="div">
                                        Supplier Details
                                    </Typography>
                                    <Table size="small" aria-label="purchases">
                                        <TableHead>
                                            <TableRow>
                                                <TableCell style={subTableHeaders}><b>Supplier</b></TableCell>
                                                <TableCell align="right" style={subTableHeaders}><b>Quantity</b></TableCell>
                                                <TableCell align="right" style={subTableHeaders}><b>Unit Price</b></TableCell>

                                                <TableCell align="right" style={subTableHeaders}><b>Last Unit Price</b></TableCell>
                                                <TableCell align="right" style={subTableHeaders}><b>Weighment Quantity</b></TableCell>
                                                <TableCell align="right" style={subTableHeaders}><b>Total price (LKR.)</b></TableCell>
                                                <TableCell align="right" style={subTableHeaders}><b>Remark</b></TableCell>
                                                <TableCell align="right" style={subTableHeaders}><b>Status</b></TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {row.supplierItems.map((itemData, i) => {
                                                if (itemData.orderItemID === row.orderItemID) {
                                                    return (
                                                        <TableRow key={i} style={(itemData.statusType === 7 || itemData.statusType === 9) ? { backgroundColor: "#FFEBEE" } : null}>
                                                            <TableCell component="th" scope="row"> {itemData.supplierName} </TableCell>
                                                            <TableCell align="right">{itemData.supplingQauntity}</TableCell>
                                                            <TableCell align="right">{roundNumber(itemData.unitPrice)}</TableCell>

                                                            <TableCell align="right">{roundNumber(itemData.lastUnitPrice)}</TableCell>
                                                            <TableCell align="right">{roundNumber(itemData.suppliedQauntity)}</TableCell>
                                                            <TableCell align="right">{roundNumber(itemData.totalPrice)}</TableCell>
                                                            <TableCell align="right">{itemData.remark ? itemData.remark : "-"}</TableCell>
                                                            <TableCell align="right">
                                                                {
                                                                    generateStatus(itemData.statusType)
                                                                }
                                                            </TableCell>
                                                        </TableRow>
                                                    )
                                                }
                                            })}
                                        </TableBody>
                                    </Table>
                                </Box> : <p style={{ fontSize: "14px" }}>No Suppliers.</p>}
                            </Collapse>
                        </TableCell>
                    </TableRow>
                </React.Fragment>
            );
        }



        return (
            <div>
                <div style={{ width: '1093px', height: '1059px', padding: '20px', marginBottom: "14rem" }}>
                    <h3><center><u>View Orders</u></center></h3>
                    <div className="row pl-2 pb-4 pt-4">
                    <div className="col"><b>Group : </b> {purchaseForPDF.group}</div>
                    <div className="col"><b>Company : </b> {purchaseForPDF.operationEntity}</div>
                    <div className="col"><b>Buyer : </b> {purchaseForPDF.buyer}</div>
                    <div className="col"><b>Invoice Date : </b> {purchaseForPDF.invoiceDate}</div>
                    <div className="col"><b>Due Date : </b> {purchaseForPDF.dueDate}</div>
                </div>
                    <div className="row">
                        <div className="col">
                            <div className="table-responsive row-top-gap">
                                <table className="display dataTable no-footer">
                                    <thead>
                                        <tr>
                                            <th>Item Name</th>
                                            <th>Purchase Manager</th>
                                            <th>Price</th>
                                            <th>Package Weight</th>
                                            <th>Measuring Unit</th>
                                            <th>Total Packages (Store)</th>
                                            <th>Max Total Packages (Export)</th>
                                            <th>Exact Amount (Kg)</th>
                                            <th>Max Amount (Kg)</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <TableContentPurchaseViewSecond
                                            data={orderItemArray.filter(x => parseInt(x.state) !== 2)}
                                            contentRowNames={contentRowNames}
                                        />
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                    <div className="row pt-4">
                        <div className="col">
                            <TableContainer component={Paper}>
                                <Table aria-label="collapsible table">
                                    <TableHead style={{ backgroundColor: "White" }}>
                                        <TableRow>
                                            <TableCell style={tableHeaderStyle}>Item Name</TableCell>
                                            <TableCell align="right" style={tableHeaderStyle}>Quantity</TableCell>
                                            <TableCell align="right" style={tableHeaderStyle}>Measuring Unit</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {itemDetails.map((row, i) => (
                                            <Row key={i} row={row} />
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}